import script from "./formTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./formTemplate.vue?vue&type=script&setup=true&lang=js"

import "./formTemplate.vue?vue&type=style&index=0&id=4d843aec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d843aec"]])

export default __exports__